import { Box, Tooltip } from "@mui/material"
import { formatMoney } from "../format-utils"

export function FrequencyBarSegment({ item, totalCost, currencySymbol }) {
    const percentage = totalCost > 0 ? (item.cost / totalCost) * 100 : 0
    if (percentage === 0) return null
    const tooltipText = `${item.label}: ${currencySymbol}${formatMoney(item.cost)} (${Math.round(percentage)}%)`

    return (
        <Tooltip title={tooltipText} arrow>
            <Box
                sx={{
                    width: `${percentage}%`,
                    bgcolor: item.color,
                    transition: "width 0.3s ease",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.85 },
                }}
            />
        </Tooltip>
    )
}
